export default __webpack_public_path__ + "static/media/8.cf233a16.jpg";